<template>
    <div class="delivery-order-item" :class="{ 'is-active': isSelected }" @click="handleClick">
        <div class="delivery-order-item__header">
            <div style="flex:1" class="flex-center-default">
                <span class="order-num">{{ data.code }}</span>
                <span class="order-status" :class="statusClass" style="margin-left: auto;">
                    {{ statusText }}
                </span>

            </div>

        </div>
        <div class="flex-center-default">
            <div class="order-item__info">
                <span class="order-item__label">{{ $t('wuliu.deliveryOrder.deliveryDrone') }}</span>
                <span class="order-item__value order-item__value-bold">{{ data.droneName || '--' }}</span>
            </div>

        </div>
        <div class="flex-center-default">
            <div class="order-item__info">
                <span class="order-item__label">{{ $t('wuliu.deliveryOrder.createTime') }}</span>
                <span class="order-item__value">
                    <TimeFormat :value="data.orderTime" format="MM-DD HH:mm" />
                </span>
            </div>
        </div>
        <div class="flex-center-default">
            <div class="order-item__info">
                <span class="order-item__label">{{ $t('wuliu.deliveryOrder.deliveryRoute') }}</span>
                <span class="order-item__value">{{ data.startSiteName }} - {{ data.endSiteName }}</span>
            </div>
        </div>
        <div class="flex-center-default" v-if="data.orderStatus == 2">
            <div class="order-item__info">
                <span class="order-item__label">{{ $t('wuliu.deliveryOrder.distanceToEnd') }}</span>
                <span class="order-item__value">200</span>
                <span style="padding-left:4px">m</span>
            </div>
        </div>
        <div class="flex-center-default">
            <div class="order-item__info">
                <span class="order-item__label">{{ $t('wuliu.deliveryOrder.takeoutNum') }}</span>
                <span class="order-item__value">{{ data.itemNum }}</span>
            </div>
        </div>
        <div class="flex-center-default">
            <div class="order-item__info">
                <span class="order-item__label">{{ $t('wuliu.common.weight') }}</span>
                <span class="order-item__value">{{ data.weight }}kg</span>
            </div>
        </div>
        <div class="flex-center-default">
            <div class="order-item__info">
                <span class="order-item__label">{{ $t('wuliu.deliveryOrder.package') }}</span>
                <span class="order-item__value">{{ `${data.length} x ${data.width} x ${data.height} cm` }}</span>
            </div>
        </div>
        <div class="flex-center-default">
            <div class="order-item__info">
                <span class="order-item__label">{{ $t('wuliu.deliveryOrder.deliveryContent') }}</span>
                <span class="order-item__value">{{ data.content }}</span>
            </div>

        </div>

        <div class="action-group">

            <span class="action-btn status-1 col-white"
                v-if="data.itemNum > 0 && data.status == DeliveryOrderStatus.CREATED.value" :title="$t('wuliu.deliveryOrder.loadComplete')"
                style="margin-right: 6px" @click.stop="onActionClick('loadComplete')">
                <!-- <span class="icon-wrap"><i class="el-icon-finished"></i></span> -->
                <span>{{ $t('wuliu.deliveryOrder.loadComplete') }}</span>
            </span>
            <el-popconfirm v-if="bottomBtns.takeoff && data.status == DeliveryOrderStatus.MOUNTED.value"
                :title="confirmTakeoffTip" style="margin-left: 6px" @confirm="onActionClick('takeoff')">
                <span @click.stop slot="reference" class="action-btn status-default" v-has="'fcs:control:cmd'">
                    <span>{{ $t('wuliu.deliveryOrder.takeoff') }}</span>
                </span>
            </el-popconfirm>
            <!-- 模拟起飞，上线再删 -->
            <el-popconfirm v-if="bottomBtns.simulateTakeoff && data.status == DeliveryOrderStatus.MOUNTED.value"
                :title="confirmSimulateTakeoffTip" style="margin-left: 6px" @confirm="onActionClick('simulateTakeoff')">
                <span @click.stop slot="reference" class="action-btn status-default">
                    <span>{{ $t('wuliu.deliveryOrder.simulateTakeoff') }}</span>
                </span>
            </el-popconfirm>
            <span
                v-if="bottomBtns.control && data.status == DeliveryOrderStatus.DELIVERING.value || data.status == DeliveryOrderStatus.RETURNING.value"
                class="action-btn status-default" @click.stop="onActionClick('control')">
                <span>{{ $t('wuliu.deliveryOrder.enterControl') }}</span>
            </span>
            <el-popconfirm popper-class="custom-popconfirm"
                v-if="data.status == DeliveryOrderStatus.WAITING_RETURN.value" :title="confirmReturnTakeoffTip"
                style="margin-left: 6px" @confirm="onActionClick('returnTakeoff')">
                <span @click.stop slot="reference" class="action-btn status-4 col-white" v-has="'fcs:control:cmd'">
                    <span>{{ $t('wuliu.deliveryOrder.returnFlight') }}</span>
                </span>
            </el-popconfirm>
            <el-popconfirm popper-class="custom-popconfirm"
                v-if="bottomBtns.simulateTakeoff && data.status == DeliveryOrderStatus.WAITING_RETURN.value"
                :title="confirmReturnTakeoffTip" style="margin-left: 6px"
                @confirm="onActionClick('simulateReturnTakeoff')">
                <span @click.stop slot="reference" class="action-btn status-4 col-white" v-has="'fcs:control:cmd'">
                    <span>{{ $t('wuliu.deliveryOrder.simulateReturnFlight') }}</span>
                </span>
            </el-popconfirm>
            <span style="margin-left: 6px" class="action-btn status-default" @click.stop="onActionClick('detail')">
                <span>{{ $t('wuliu.common.detail') }}</span>
            </span>
            <span class="action-btn status-1 col-white"
                v-if="data.itemNum > 0 && data.status == DeliveryOrderStatus.MOUNTED.value" :title="$t('wuliu.deliveryOrder.changeDrone')"
                style="margin-left: 6px" @click.stop="onActionClick('loadComplete')">
                <span>{{ $t('wuliu.deliveryOrder.changeDrone') }}</span>
            </span>
            <el-popconfirm v-if="data.status == '0'" :title="$t('wuliu.deliveryOrder.confirmDelete')" style="margin-left: 6px"
                @confirm="onActionClick('delete')">
                <span :title="$t('wuliu.common.delete')" @click.stop slot="reference" class="text-error action-btn btn-del">

                    <span>{{ $t('wuliu.common.delete') }}</span>
                </span>
            </el-popconfirm>
        </div>
        <el-dialog :visible.sync="dialogVisible" :title="$t('wuliu.deliveryOrder.confirmLoadComplete')" width="500px" append-to-body>
            <div style="line-height: 1.5;">
                <div>
                    <el-form ref="form" :model="formData" :rules="rules">
                        <el-form-item :label="$t('wuliu.deliveryOrder.selectDrone')" prop="droneId">
                            <el-select v-model="formData.droneId" :placeholder="$t('wuliu.deliveryOrder.pleaseSelectDrone')" clearable>
                                <el-option v-for="item in uavList" :key="item.value" :label="item.label"
                                    :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div>
                    <i class="el-icon-info" style="color:red"></i>
                    {{ $t('wuliu.deliveryOrder.loadCompleteTip') }}
                </div>

            </div>
            <div class="dialog-footer" slot="footer">
                <el-button @click="dialogVisible = false">{{ $t('wuliu.common.cancel') }}</el-button>
                <el-button type="primary" @click="handleSubmit">{{ $t('wuliu.common.confirm') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
/**
 * 配送单 list item组件
 */
import TimeFormat from '@/components/TimeFormat';
import OrderApi from '@/page/business/wuliu/api/order';
import OrderTaskApi from '@/page/business/wuliu/api/OrderTask';
import DroneApi from '@/api/flight/drone';
import { DeliveryOrderStatus } from '@/page/business/wuliu/constants';

const defaultBtns = {
    mounted: true, // 完成装载按钮
    takeoff: true, // 起飞按钮
    simulateTakeoff: true, // 模拟起飞按钮
    detail: true, // 详情按钮
    delete: true, // 删除按钮
    control: true, // 进入控制按钮
};
export default {
    components: {
        TimeFormat,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            },
        },
        // 是否选中状态，用于选中样式
        isSelected: {
            type: Boolean,
            default: false,
        },
        uavList: {
            type: Array,
            default() {
                return [];
            },
        },
        refreshData: {
            type: Function,
            default() {
                return () => { };
            },
        },
        /**
         * 底部按钮配置
         *  mounted: true,//完成装载按钮
         * takeoff: true,//起飞按钮
         * simulateTakeoff: true,//模拟起飞按钮
         * detail: true,//详情按钮
         * delete: true,//删除按钮
        */
        btnsConfig: {
            type: Object,
            default() {
                return {
                    ...defaultBtns,
                };
            },
        },
    },

    data() {
        return {

            DeliveryOrderStatus,
            dialogVisible: false,
            formData: {
                id: '', // 配送订单ID
                droneId: '', // 无人机ID
            },
            rules: {
                droneId: [
                    { required: true, message: this.$t('wuliu.deliveryOrder.pleaseSelectDrone'), trigger: 'blur' },
                ],
            },
            // confirmTakeoffTip: '确定起飞吗？',
            // confirmReturnTakeoffTip: '无人机将会起飞并返程到配送点，确定吗？',
            confirmTakeoffTip: this.$t('wuliu.deliveryOrder.confirmTakeoffTip'),
            confirmReturnTakeoffTip: this.$t('wuliu.deliveryOrder.confirmReturnTakeoffTip'),
            confirmSimulateTakeoffTip: this.$t('wuliu.deliveryOrder.confirmSimulateTakeoffTip'),
        };
    },
    computed: {
        bottomBtns() {
            let btns = { ...defaultBtns };
            return { ...btns, ...this.btnsConfig };
        },
        // eslint-disable-next-line vue/return-in-computed-property, consistent-return
        statusText() {
            if (!this.data) {
                return '';
            }
            if (this.data) {
                return this.data.statusLabel || '';
            }
        },
        statusClass() {
            if (!this.data) {
                return '';
            }
            let style = `status-${Number(this.data.status)}`;
            return style;
        },
    },
    methods: {
        handleClick() {
            this.$emit('click', this.data);
        },
        handleAccept() {
            this.$emit('accept', this.data);
        },
        onActionClick(action) {
            // eslint-disable-next-line default-case
            switch (action) {
                case 'loadComplete':
                    this.dialogVisible = true;
                    break;
                case 'detail':
                    this.$emit('detail', this.data);
                    break;
                case 'takeoff':
                    this.handleTakeoff();
                    break;
                case 'simulateTakeoff':// 模拟起飞
                    this.handleTakeoff(true);
                    break;
                case 'returnTakeoff':// 返程起飞，从收货点起飞返回到配送点
                    this.handleReturnTakeoff();
                    break;
                case 'simulateReturnTakeoff':// 模拟返程起飞，从收货点起飞返回到配送点
                    this.handleReturnTakeoff(true);
                    break;
                case 'control':// 进入控制

                    this.handleEnterControl();
                    break;
                case 'delete':
                    this.handleDelete();
                    break;
            }
        },
        handleDelete() {
            if (this.data && this.data.itemNum > 0) {
                this.$message.error(this.$t('wuliu.deliveryOrder.deleteWithItemsTip'));
                return;
            }
            this.$emit('delete', this.data);
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let params = {
                        id: this.data.id,
                        droneId: this.formData.droneId,
                    };
                    OrderApi.fetchLoadComplete(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(this.$t('common.operationSuccess'));
                            this.dialogVisible = false;
                        } else {
                            this.$message.error(res.msg);
                        }
                        if (typeof this.refreshData === 'function') {
                            this.refreshData();
                        }
                    });
                }
            });
        },
        /**
         * 起飞
         * @param isSimulate 是否模拟起飞
        */
        handleTakeoff(isSimulate = false) {
            if (isSimulate) {
                let param = {
                    orderId: this.data.id,
                    simulation: isSimulate, // 是否模拟起飞
                };
                OrderTaskApi.fetchTakeoff(param).then((res) => {
                    if (res.code === 200) {
                        this.$message.success(this.$t('common.operationSuccess'));
                    } else {
                        this.$message.error(res.msg);
                    }
                    if (typeof this.refreshData === 'function') {
                        this.refreshData();
                    }
                });
            } else {
                let param = {
                    orderId: this.data.id,
                    type: 0, // 0:出航,1: 返程
                    simulation: isSimulate, // 是否模拟起飞
                };

                OrderTaskApi.fetchCreateFlightTask(param).then((res) => {
                    if (res.code === 200) {
                        const data = res.data;
                        this.$router.push({
                            path: '/console',
                            query: {
                                taskId: data.taskId,
                                dockId: data.dockId,
                                droneSn: data.droneSn,
                                page: '/wuliu/dispatch',
                            },
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        /**
         *
         * @param isSimulate 是否模拟返航
        */
        handleReturnTakeoff(isSimulate = false) {
            if (isSimulate) {
                let param = {
                    orderId: this.data.id,
                    simulation: isSimulate, // 是否模拟起飞
                };
                OrderTaskApi.fetchReturnTakeoff(param).then((res) => {
                    if (res.code === 200) {
                        this.$message.success(this.$t('common.operationSuccess'));
                    } else {
                        this.$message.error(res.msg);
                    }
                    if (typeof this.refreshData === 'function') {
                        this.refreshData();
                    }
                });
            } else {
                let param = {
                    orderId: this.data.id,
                    type: 1, // 0:出航,1: 返程
                    simulation: isSimulate, // 是否模拟起飞
                };

                OrderTaskApi.fetchCreateFlightTask(param).then((res) => {
                    if (res.code === 200) {
                        const data = res.data;
                        this.$router.push({
                            path: '/console',
                            query: {
                                taskId: data.taskId,
                                dockId: data.dockId,
                                droneSn: data.droneSn,
                            },
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        /**
         * 进入控制界面
        */
        handleEnterControl() {
            const droneId = this.data.droneId;
            DroneApi.fetchDroneInfo(droneId).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.$router.push({
                        path: '/console',
                        query: {
                            droneSn: data.droneSn || data.serial,
                            page: '/wuliu/dispatch',
                        },
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    },
    mounted() { },
};
</script>

<style lang="scss" scoped>
$colorLight: #5bf0fc;
$borderColor: #1E76ED;
$hoverBgColor: rgba(91, 240, 252, 0.1);

.delivery-order-item {
    padding: 10px;
    border-bottom: 1px solid $borderColor;
    line-height: 1.5;

    &.is-active {
        background-color: $hoverBgColor;
    }

    &__header {
        display: flex;
        align-items: center;
    }

    .order-num {
        font-size: 18px;
        color: $colorLight;
        font-weight: bold;
        // flex: 1
    }

    .order-status {
        font-size: 12px;
        padding: 0px 4px;
        color: #ffffff;
        margin-left: 10px;
        // background-color: #172f71;
        border-radius: 2px;
        flex-shrink: 0;

    }

    .action-group {
        margin-top: 8px;
        text-align: right;
    }

    .action-btn {
        display: inline-block;
        min-width: 60px !important;
        text-align: center;
        padding: 2px 4px;
        color: #000000;
        border-radius: 2px;
        flex-shrink: 0;
        cursor: pointer;
        font-size: 12px;
        line-height: 23px;

        .icon-wrap {
            margin-right: 2px;
        }

        &+& {
            margin-left: 6px;
        }

    }

    .btn-del {
        border: #FF4949;
        background: #FF494940;
    }

    .order-item__info {
        &+.order-item__info {
            margin-left: 10px;
        }
    }

    .order-item__label {
        margin-right: 4px;
        color: #D0D0D0;
        position: relative;
        display: inline-block;
        font-size: 14px;
        width: 70px;
        margin-right: 8px;
        /* 文字两端对齐（针对多字标签） */
        // text-align-last: justify;

        /* 与右侧内容垂直居中对齐 */
        // &::after {
        //     content: "：";

        // }
    }

    .order-item__value {
        color: #49F0FD;
        font-size: 14px;

        &-bold {
            font-weight: bold;
            font-size: 18px;
        }
    }
}

.col-white {
    color: #ffffff !important;
}

.status-default {
    border: 1px solid $colorLight;
    background: #49F0FD;
}

.status-0 {
    border: #FD9449 1px solid;
    background-color: #FD944950
}

.status-1 {
    border: #FFC300 1px solid;
    background-color: #FFC30050
}

.status-2 {
    border: #19B055 1px solid;
    background-color: #19B05550
}

.status-3 {
    border: #29EB1F 1px solid;
    background-color: #29EB1F50;
}

.status-4 {
    border: #FD4994 1px solid;
    background-color: #FD499450
}

.status-5 {
    border: #49FDFD 1px solid;
    background-color: #49FDFD50
}

.status-6 {
    border: #BEBEBE 1px solid;
    background-color: #BEBEBE50
}

.status-7 {
    border: #FF4949 1px solid;
    background-color: #FF494950
}

.status-8 {
    border: #6549FF 1px solid;
    background-color: #6549FF50;
}
</style>
<style lang="scss">
.custom-popconfirm {
    width: 200px;
}
</style>
